import React, { useEffect } from "react";
import CountryPrices from "../CountryPrices";
import Form from "../Form";
import { changeTitle } from "../../helpers/changeTitle";

const BrandStep = props => {
	let info = props.info;
	let value = props.step + 1;
	useEffect(() => {
		window.scrollTo(0, 0);
	});

	const header = {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		paddingTop: "2rem"
	};

	const stepBack = {
		display: "flex",
		flexDirection: "row",
		textTransform: "uppercase",
		alignItems: "center",
		color: "rgb(167,167,167)",
		width: "12rem",
		cursor: "pointer"
	};

	const mail = {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		textTransform: "uppercase",
		color: "rgb(99,221,105)",
		width: "12rem",
		cursor: "pointer",
		marginRight: "0.5rem"
	};

	const text = {
		maxWidth: "1200px",
		marginTop: "2rem",
		display: "flex",
		textAlign: "left"
	};

	const logo = {
		maxWidth: "5rem",
		maxHeight: "5rem"
	};

	const logoText = {
		fontWeight: "bold",
		marginTop: "1.3rem"
	};

	const price = {
		fontWeight: "500",
		fontSize: "3rem",
		margin: "1rem 0"
	};

	const countryPrices = {
		maxWidth: "80rem"
	};

	const bottomBlock = {
		marginTop: "4rem",
		display: "flex",
		flexDirection: "column",
		alignItems: "center"
	};

	const bottomText = {
		color: "rgb(99,221,105)",
		textTransform: "uppercase",
		fontWeight: "bold"
	};

	const greenArrow = {
		marginTop: "1rem",
		maxWidth: "2rem",
		maxHeight: "6.5rem"
	};

	return (
		<div>
			<div className="brandHeader" style={header}>
				<a
					className="alternativeTitle arrowBack"
					href="/skaiciuokle"
					onClick={() => {
						props.changePage(0);
						props.changeActive(true);
						window.history.pushState(
							{},
							"",
							"/skaiciuokle"
						);
						changeTitle("Kiek kainuoja sukurti mobilią programėlė");
					}}
					style={stepBack}
				>
					<img
						alt="silverArrow"
						className="silverArrow"
						src="/skaiciuokle/img/silverArrow.png"
					/>
					<div>Atgal</div>
				</a>
				<a href="#contact-form">
					<div className="alternativeTitle" style={mail}>
						<div>Siųsti užklausą</div>
						<img
							alt="mail"
							className="mailIcon"
							src={"/skaiciuokle/img/mail.png"}
						/>
					</div>
				</a>
			</div>

			<div style={props.contentStyle}>
				<img
					alt="brandLogo"
					className="brandLogo"
					src={`/skaiciuokle/img/brand0${value}.png`}
				/>

				<div className="mainTitle brandTitle">{info.title}</div>

				<div style={text}>
					<div className="textBlock">{info.text}</div>
				</div>

				<div className="brandLogos">
					<div
						className="brandPriceBlock"
						style={{ paddingTop: "1rem" }}
					>
						<img
							style={logo}
							alt="brandLogo"
							src={"/skaiciuokle/img/step00.png"}
						/>
						<div style={logoText}>Pilnai išbaigtas produktas</div>
						<div style={{ marginTop: "auto" }}>
							<div style={price}>€ {info.price[0]}</div>
							<div className="subText">
								Įvertinta pagal 30€/val. įkainį
							</div>
						</div>
					</div>

					<div className="brandPriceBlock">
						<img
							style={logo}
							alt="brandLogo"
							src={"/skaiciuokle/img/step01.png"}
						/>
						<div style={logoText}>
							Apkarpyto funkcionalumo produktas
						</div>
						<div style={{ marginTop: "auto" }}>
							<div style={price}>€ {info.price[1]}</div>
							<div className="subText">
								Įvertinta pagal 30€/val. įkainį
							</div>
						</div>
					</div>

					<div className="brandPriceBlock">
						<img
							style={logo}
							alt="brandLogo"
							src={"/skaiciuokle/img/step02.png"}
						/>
						<div style={logoText}>
							Minimalus produktas <br />
							(MVP)
						</div>
						<div style={{ marginTop: "auto" }}>
							<div style={price}>€ {info.price[2]}</div>
							<div className="subText">
								Įvertinta pagal 30€/val. įkainį
							</div>
						</div>
					</div>
				</div>

				<div style={countryPrices}>
					<CountryPrices />
				</div>
				<a href="#contact-form">
					<div className="alternativeTitle" style={bottomBlock}>
						<div style={bottomText}>
							Nusiųsti užklausą dėl projekto įgyvendinimo
						</div>
						<img
							style={greenArrow}
							alt="greenArrow"
							src={"/skaiciuokle/img/greenArrow.png"}
						/>
					</div>
				</a>
				<Form />
			</div>
		</div>
	);
};

export default BrandStep;
